import * as React from "react"
import { SVGProps } from "react"
const CheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width}
    height={props?.height}
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      stroke="#76A973"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8.126 13 3.25 3.25 6.5-6.5M23.835 13c0 5.983-4.85 10.833-10.834 10.833-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833 5.983 0 10.834 4.85 10.834 10.833Z"
    />
  </svg>
)
export default CheckCircle
